import React from 'react';
import Formsy from 'formsy-react';
import withOnboarding from '../onboarding/withOnboarding';

class OnboardingSubmitDefault extends React.Component {
  render() {
    const {
      actions,
      isValid,
      enabledCopy = 'Continue',
      disabledCopy = 'Enter Info'
    } = this.props;
    return (
      <Formsy
        className="on-boarding__submit-form"
        onSubmit={actions.triggerSubmit}
        onValid={this.handleValid}
        onInvalid={this.handleInvalid}
      >
        <input
          type="submit"
          className="btn btn--solid-blue btn--full-width"
          value={isValid ? enabledCopy : disabledCopy}
          disabled={!isValid}
        />
      </Formsy>
    );
  }

  handleValid = () => this.props.actions.setValidState('submit', true);
  handleInvalid = () => this.props.actions.setValidState('submit', false);
  componentDidMount() {
    this.props.actions.setValidState('submit', true);
  }
}
export default withOnboarding(OnboardingSubmitDefault);



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingSubmitDefault.js